// Router shell. Only the three SPA rungs are routed here.
//
// /weekly, /weekly/latest, /b/<slug>, /confirm, /unsubscribe and /manage are
// deliberately NOT routes: they are server-rendered by ai-portal on chloe and
// must reach it as real document requests. Adding them here would shadow the
// server pages with a blank React view.

import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Meetings from './pages/Meetings';
import Blip from './pages/Blip';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/meetings" element={<Meetings />} />
        <Route path="/blip" element={<Blip />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
